import React, {useState} from 'react';
import classNames from "classnames";

import {useAppState} from "@stores/AppStateContext";
import {ClientUser, WorkspaceUser} from "../../../API";
import {MoreVerticalIcon} from "../../components/icons/MoreVerticalIcon";
import {toggleContextMenu} from "../../elements/context-menu/toggleContextMenu";

export interface WsUserCardProps {
    user: ClientUser;
    wsUser: WorkspaceUser;
    className?: string;
}

export const WsUserActions = ({user, wsUser, className}: WsUserCardProps) => {
    const appState = useAppState();
    // Keep the trigger button visible while its menu is open, even if the row
    // is no longer hovered (mirrors ItemLine's isMoreClicked behavior).
    const [isMenuOpen, setMenuOpen] = useState(false);

    const openMenu = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        const target = event.currentTarget;
        if (!isMenuOpen) {
            setMenuOpen(true);
        }
        toggleContextMenu(appState, {
            id: `ws-member-options-${user.id}`,
            type: 'ws-member-row-options',
            shouldForcePlace: true,
            menuPlacement: 'block-end',
            menuAlignment: 'end',
            VERTICAL_SHIFT: 4,
            HORIZONTAL_SHIFT: 0,
            getTargetBoundingBox: target.getBoundingClientRect.bind(target),
            params: {user, wsUser},
            onClose: () => setMenuOpen(false),
        });
    };

    return (
        <div
            className={classNames({
                [className!]: className,
                'Members__delete--menuOpen': isMenuOpen,
            })}
        >
            <MoreVerticalIcon
                size={20}
                className={'Members-icon'}
                onClick={openMenu}
            />
        </div>
    );
};
